import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RECIPE_TRANSLATION_ICONS_PATH } from '@shared/constants/icons-paths.constant';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-recipes-translation-header-actions',
  templateUrl: './recipes-translation-header-actions.component.html',
  styleUrls: ['./recipes-translation-header-actions.component.scss'],
  imports: [TranslateModule, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecipesTranslationHeaderActionsComponent {
  @Input() buttonsDisabled: boolean;
  @Output() translationApproved = new EventEmitter<boolean>();

  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
  ) {
    this.loadSvgIcons();
  }

  private loadSvgIcons(): void {
    this.matIconRegistry.addSvgIcon(
      'ic_save',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`../../../../${RECIPE_TRANSLATION_ICONS_PATH}/ic_save.svg`),
    );
  }
}
